/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { FormattedMessage } from "react-intl"
import { ButtonPrimary } from "../atoms/buttons/ButtonPrimary"
import { SupportCenterLinks } from "../../../utils/SupportCenterLinks"
import { ZendeskTextLink } from "../atoms/links/ZendeskTextLink"
import { useDispatch } from "react-redux"
import { fetchReimbursementDetails } from "../../../actions/reimbursementDetailsActions"

// view component immediately after successfully completing carrot card activation
const ActivateSuccess = () => {
  const dispatch = useDispatch()

  const fetchUpdatedReimbursementDetails = async () => {
    await dispatch(fetchReimbursementDetails())
  }

  return (
    <div className="mw6 center tc pa3">
      <h1 className="publico-text mt0 mb4 black">
        <FormattedMessage defaultMessage="Success!" />
      </h1>
      <p className="lh-copy mt0 mb3 black-60">
        <FormattedMessage defaultMessage="Your Carrot Card® is now active. You may now start using your card to pay for eligible care." />
      </p>
      <p className="lh-copy mb0 mb4">
        <ZendeskTextLink supportCenterLink={SupportCenterLinks.CARROT_CARD_SUPPORT_CENTER}>
          <FormattedMessage defaultMessage="How to use your Carrot Card" />
        </ZendeskTextLink>
      </p>
      <ButtonPrimary to="/transactions" onClick={fetchUpdatedReimbursementDetails}>
        <FormattedMessage defaultMessage="Continue to your benefit dashboard"></FormattedMessage>
      </ButtonPrimary>
    </div>
  )
}

export default ActivateSuccess
